export default "__VITE_ASSET__BSb_vUKO__"